import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.object.from-entries.js";
import '@plasmicapp/preamble';
import * as React from 'react';
import React__default, { isValidElement, cloneElement, useState, useCallback, createContext, useContext, useEffect, createElement, Fragment, useLayoutEffect, Component } from 'react';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var root = globalThis;
root.__PlasmicFetcherRegistry = [];

function registerFetcher(fetcher, meta) {
  root.__PlasmicFetcherRegistry.push({
    fetcher: fetcher,
    meta: meta
  });
}

function isString(x) {
  return typeof x === "string";
}

function ensure(x, msg) {
  if (msg === void 0) {
    msg = "";
  }

  if (x === null || x === undefined) {
    debugger;
    msg = (isString(msg) ? msg : msg()) || "";
    throw new Error("Value must not be undefined or null" + (msg ? "- " + msg : ""));
  } else {
    return x;
  }
}

var root$1 = globalThis;

if (root$1.__PlasmicComponentRegistry == null) {
  root$1.__PlasmicComponentRegistry = [];
}

function registerComponent(component, meta) {
  root$1.__PlasmicComponentRegistry.push({
    component: component,
    meta: meta
  });
}

var root$2 = globalThis;

if (root$2.__PlasmicContextRegistry == null) {
  root$2.__PlasmicContextRegistry = [];
}

function registerGlobalContext(component, meta) {
  root$2.__PlasmicContextRegistry.push({
    component: component,
    meta: meta
  });
}

var _root$__Sub$setRepeat, _root$__Sub;
/**
 * Allows a component from Plasmic Studio to be repeated.
 * `isPrimary` should be true for at most one instance of the component, and
 * indicates which copy of the element will be highlighted when the element is
 * selected in Studio.
 * If `isPrimary` is `false`, and `elt` is a React element (or an array of such),
 * it'll be cloned (using React.cloneElement) and ajusted if it's a component
 * from Plasmic Studio. Otherwise, if `elt` is not a React element, the original
 * value is returned.
 */


function repeatedElement(isPrimary, elt) {
  return repeatedElementFn(isPrimary, elt);
}

var repeatedElementFn = function repeatedElementFn(isPrimary, elt) {
  if (isPrimary) {
    return elt;
  }

  if (Array.isArray(elt)) {
    return elt.map(function (v) {
      return repeatedElement(isPrimary, v);
    });
  }

  if (elt && isValidElement(elt) && typeof elt !== "string") {
    return cloneElement(elt);
  }

  return elt;
};

var root$3 = globalThis;
var setRepeatedElementFn = (_root$__Sub$setRepeat = root$3 == null ? void 0 : (_root$__Sub = root$3.__Sub) == null ? void 0 : _root$__Sub.setRepeatedElementFn) != null ? _root$__Sub$setRepeat : function (fn) {
  repeatedElementFn = fn;
};

function useForceUpdate() {
  var _useState = useState(0),
      setTick = _useState[1];

  var update = useCallback(function () {
    setTick(function (tick) {
      return tick + 1;
    });
  }, []);
  return update;
}

var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

var DataContext = /*#__PURE__*/createContext(undefined);

function applySelector(rawData, selector) {
  if (!selector) {
    return undefined;
  }

  var curData = rawData;

  for (var _iterator = _createForOfIteratorHelperLoose(selector.split(".")), _step; !(_step = _iterator()).done;) {
    var _curData;

    var key = _step.value;
    curData = (_curData = curData) == null ? void 0 : _curData[key];
  }

  return curData;
}

function useSelector(selector) {
  var rawData = useDataEnv();
  return applySelector(rawData, selector);
}

function useSelectors(selectors) {
  if (selectors === void 0) {
    selectors = {};
  }

  var rawData = useDataEnv();
  return Object.fromEntries(Object.entries(selectors).filter(function (_ref) {
    var key = _ref[0],
        selector = _ref[1];
    return !!key && !!selector;
  }).map(function (_ref2) {
    var key = _ref2[0],
        selector = _ref2[1];
    return tuple(key, applySelector(rawData, selector));
  }));
}

function useDataEnv() {
  return useContext(DataContext);
}

function DataProvider(_ref3) {
  var _useDataEnv;

  var name = _ref3.name,
      data = _ref3.data,
      children = _ref3.children;
  var existingEnv = (_useDataEnv = useDataEnv()) != null ? _useDataEnv : {};

  if (!name) {
    return React__default.createElement(React__default.Fragment, null, children);
  } else {
    var _extends2;

    return React__default.createElement(DataContext.Provider, {
      value: _extends({}, existingEnv, (_extends2 = {}, _extends2[name] = data, _extends2))
    }, children);
  }
}

function DataCtxReader(_ref4) {
  var children = _ref4.children;
  var $ctx = useDataEnv();
  return children($ctx);
}

var root$4 = globalThis;

if (root$4.__PlasmicHostVersion == null) {
  root$4.__PlasmicHostVersion = "2";
}

var rootChangeListeners = [];

var PlasmicRootNodeWrapper = function PlasmicRootNodeWrapper(value) {
  var _this = this;

  this.value = value;

  this.set = function (val) {
    _this.value = val;
    rootChangeListeners.forEach(function (f) {
      return f();
    });
  };

  this.get = function () {
    return _this.value;
  };
};

var plasmicRootNode = /*#__PURE__*/new PlasmicRootNodeWrapper(null);

function getPlasmicOrigin() {
  var params = new URL("https://fakeurl/" + location.hash.replace(/#/, "?")).searchParams;
  return ensure(params.get("origin"), "Missing information from Plasmic window.");
}

function renderStudioIntoIframe() {
  var script = document.createElement("script");
  var plasmicOrigin = getPlasmicOrigin();
  script.src = plasmicOrigin + "/static/js/studio.js";
  document.body.appendChild(script);
}

var renderCount = 0;

function setPlasmicRootNode(node) {
  // Keep track of renderCount, which we use as key to ErrorBoundary, so
  // we can reset the error on each render
  renderCount++;
  plasmicRootNode.set(node);
}
/**
 * React context to detect whether the component is rendered on Plasmic editor.
 * If not, return false.
 * If so, return an object with more information about the component
 */


var PlasmicCanvasContext = /*#__PURE__*/createContext(false);

var usePlasmicCanvasContext = function usePlasmicCanvasContext() {
  return useContext(PlasmicCanvasContext);
};

function _PlasmicCanvasHost() {
  var _location$hash, _location$hash2; // If window.parent is null, then this is a window whose containing iframe
  // has been detached from the DOM (for the top window, window.parent === window).
  // In that case, we shouldn't do anything.  If window.parent is null, by the way,
  // location.hash will also be null.


  var isFrameAttached = !!window.parent;
  var isCanvas = !!((_location$hash = location.hash) != null && _location$hash.match(/\bcanvas=true\b/));
  var isLive = !!((_location$hash2 = location.hash) != null && _location$hash2.match(/\blive=true\b/)) || !isFrameAttached;
  var shouldRenderStudio = isFrameAttached && !document.querySelector("#plasmic-studio-tag") && !isCanvas && !isLive;
  var forceUpdate = useForceUpdate();
  useLayoutEffect(function () {
    rootChangeListeners.push(forceUpdate);
    return function () {
      var index = rootChangeListeners.indexOf(forceUpdate);

      if (index >= 0) {
        rootChangeListeners.splice(index, 1);
      }
    };
  }, [forceUpdate]);
  useEffect(function () {
    if (shouldRenderStudio && isFrameAttached && window.parent !== window) {
      renderStudioIntoIframe();
    }
  }, [shouldRenderStudio, isFrameAttached]);
  useEffect(function () {
    if (!shouldRenderStudio && !document.querySelector("#getlibs") && isLive) {
      var scriptElt = document.createElement("script");
      scriptElt.id = "getlibs";
      scriptElt.src = getPlasmicOrigin() + "/static/js/getlibs.js";
      scriptElt.async = false;

      scriptElt.onload = function () {
        window.__GetlibsReadyResolver == null ? void 0 : window.__GetlibsReadyResolver();
      };

      document.head.append(scriptElt);
    }
  }, [shouldRenderStudio]);

  if (!isFrameAttached) {
    return null;
  }

  if (isCanvas || isLive) {
    var appDiv = document.querySelector("#plasmic-app.__wab_user-body");

    if (!appDiv) {
      appDiv = document.createElement("div");
      appDiv.id = "plasmic-app";
      appDiv.classList.add("__wab_user-body");
      document.body.appendChild(appDiv);
    }

    var locationHash = new URLSearchParams(location.hash);
    var plasmicContextValue = isCanvas ? {
      componentName: locationHash.get("componentName")
    } : false;
    return createPortal(createElement(ErrorBoundary, {
      key: "" + renderCount
    }, createElement(PlasmicCanvasContext.Provider, {
      value: plasmicContextValue
    }, plasmicRootNode.get())), appDiv, "plasmic-app");
  }

  if (shouldRenderStudio && window.parent === window) {
    return createElement("iframe", {
      src: "https://docs.plasmic.app/app-content/app-host-ready#appHostUrl=" + encodeURIComponent(location.href),
      style: {
        width: "100vw",
        height: "100vh",
        border: "none",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 99999999
      }
    });
  }

  return null;
}

var PlasmicCanvasHost = function PlasmicCanvasHost(props) {
  var enableWebpackHmr = props.enableWebpackHmr;

  var _React$useState = useState(null),
      node = _React$useState[0],
      setNode = _React$useState[1];

  useEffect(function () {
    setNode(createElement(_PlasmicCanvasHost, null));
  }, []);
  return createElement(Fragment, null, !enableWebpackHmr && createElement(DisableWebpackHmr, null), node);
};

if (root$4.__Sub == null) {
  // Creating a side effect here by logging, so that vite won't
  // ignore this block for whatever reason
  console.log("Plasmic: Setting up app host dependencies");
  root$4.__Sub = {
    React: React,
    ReactDOM: ReactDOM,
    // Must include all the dependencies used by canvas rendering,
    // and canvas-package (all hostless packages) from host
    setPlasmicRootNode: setPlasmicRootNode,
    registerRenderErrorListener: registerRenderErrorListener,
    repeatedElement: repeatedElement,
    setRepeatedElementFn: setRepeatedElementFn,
    PlasmicCanvasContext: PlasmicCanvasContext,
    DataProvider: DataProvider,
    useDataEnv: useDataEnv,
    useSelector: useSelector,
    useSelectors: useSelectors,
    applySelector: applySelector,
    DataCtxReader: DataCtxReader
  };
}

var renderErrorListeners = [];

function registerRenderErrorListener(listener) {
  renderErrorListeners.push(listener);
  return function () {
    var index = renderErrorListeners.indexOf(listener);

    if (index >= 0) {
      renderErrorListeners.splice(index, 1);
    }
  };
}

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    var _this2;

    _this2 = _React$Component.call(this, props) || this;
    _this2.state = {};
    return _this2;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error) {
    renderErrorListeners.forEach(function (listener) {
      return listener(error);
    });
  };

  _proto.render = function render() {
    if (this.state.error) {
      return createElement("div", null, "Error: ", "" + this.state.error.message);
    } else {
      return this.props.children;
    }
  };

  return ErrorBoundary;
}(Component);

function DisableWebpackHmr() {
  if (process.env.NODE_ENV === "production") {
    return null;
  }

  return createElement("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: "\n      if (typeof window !== \"undefined\") {\n        const RealEventSource = window.EventSource;\n        window.EventSource = function(url, config) {\n          if (/[^a-zA-Z]hmr($|[^a-zA-Z])/.test(url)) {\n            console.warn(\"Plasmic: disabled EventSource request for\", url);\n            return {\n              onerror() {}, onmessage() {}, onopen() {}, close() {}\n            };\n          } else {\n            return new RealEventSource(url, config);\n          }\n        }\n      }\n      "
    }
  });
}

export { DataContext, DataCtxReader, DataProvider, PlasmicCanvasContext, PlasmicCanvasHost, applySelector, registerComponent, registerGlobalContext, repeatedElement, registerFetcher as unstable_registerFetcher, useDataEnv, usePlasmicCanvasContext, useSelector, useSelectors };